module.exports = __webpack_public_path__ + "img/content_copy-black-24dp.51a55284.svg";